
import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import productOptionMixin from '@/mixin/productOption'
import currencyOptionMixin from '@/mixin/currencyOption'
import { getExOrderList, tableExport } from '@/api/task/exOrder'
import { dateToSeconds, pickerOptions, getCurrentDate } from '@/utils/dateTime'
import pagination from '@/components/Pagination/index.vue'
import { delObjEmptyKey } from '@/utils'
import { auditAddStatusList, timeTypeList } from '@/utils/constant'
import orderDetail from './components/orderDetail.vue'
import review from './components/review.vue'
import batchReview from './components/batchReview.vue'
import { AppModule } from '@/store/modules/app'
import { getProductList } from '@/api/product/product'
import { getProductAccountList } from '@/api/product/productAccount'
import { getType } from '@/utils/cookies'
import { getAntBuyTask, antBuyExport } from '@/api/product/recharge'

@Component({
  name: 'exOrderIndex',
  components: {
    pagination,
    orderDetail,
    review,
    batchReview,
  },
  filters: {
    // action_filter: function (v: string) {
    //   let filter_list = {
    //     order: 'Callback Order',
    //     balance: 'Add Balance'
    //   }
    //   return filter_list[`${v}`]
    // }
  },
})
export default class extends mixins(currencyOptionMixin) {
  queryForm: any = {
    start_time: null,
    end_time: null,
    status: null,
    content: null,
    begin_handle_time: null,
    end_handle_time: null,
    handle_time_unit: timeTypeList[0],
    product_name: null, // 产品
    product_account_name: null, // 产品账户
    exception_type: null,
    upstream_ordernumber: null,
    id: null,
    min_amount: null,
    max_amount: null,
  }
  private statusList: any[] = auditAddStatusList
  private exTypeList: any[] = []
  private timeTypeList = timeTypeList
  private date: any[] = getCurrentDate()
  private handleDate: any[] = []
  private pickerOptions = pickerOptions
  private sendLoading: boolean = false
  private orderList: any[] = []
  private listLoading: Boolean = false
  private total = 0
  private listQuery = {
    page: 1,
    limit: 20,
  }

  private currentProduct: any = {} // 当前选中的产品对象

  // 产品列表
  private productList: any[] = []
  private onProductList: any[] = []
  private async getProductLists() {
    const data: any = {
      status: 1,
      name: 'IMPS',
    }
    await getProductList(data).then((res: any) => {
      this.productList = res
      // this.onProductList = this.productList.filter((item: any) => {
      //   return this.queryForm.currency === item.currency
      // })
      this.onProductList = this.productList.filter((item: any) => {
        return item.in_or_out === 1
      })
    })
  }

  // 产品账户
  private productAccountList: any[] = []
  private async getProductAccountList(code: any) {
    let data = {}
    if (this.queryForm.product_code) {
      data = {
        account_name: code,
        product_code: this.queryForm.product_code,
      }
    } else {
      data = {
        account_name: code,
      }
    }
    delObjEmptyKey(data)
    await getProductAccountList(data).then((res: any) => {
      this.productAccountList = res.results
    })
  }

  private async changeProductCode(product: any) {
    let data = {
      product_code: product,
    }
    delObjEmptyKey(data)
    await getProductAccountList(data).then((res: any) => {
      this.productAccountList = res.results
    })
    let arr = this.productList.filter((item) => {
      if (product === item.code) {
        this.currentProduct = item.product_account_param
      }
    })
    console.log(this.currentProduct, 'this.currentProduct')
  }

  private currentOrder: any | null = null
  private drawer: boolean = false
  private dialogVisible: boolean = false
  private dialogVisible1: boolean = false
  private restaurants: any = []
  private timeout: any = null

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      const data = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage,
      }
      this.orderList = []
      delObjEmptyKey(data)
      await getAntBuyTask(data).then((res: any) => {
        this.total = res.count
        this.orderList = this.handleContentText(res.results)
        // this.orderList = res.results
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private handleContentText(list: any[]) {
    return list.map((item: any) => {
      const content: string = item.content
      if (item.product_account_type === 'erc20') {
        if (content) {
          const strs = content.split('|').map((str: any) => {
            if (str.includes('system ref')) {
              str = `<span style="color: sandybrown;">` + str + `</span>`
            }
            if (str.includes('deposit_address')) {
              let w = str.split('deposit_address', 2)[1]
              let a = w.split('(', 2)[1]
              let b = a.split(')', 2)[0]
              str =
                `<span> deposit_address(</span>
              <span onclick="ercJumpAddress('${b}')" style="color:#1890ff;cursor:pointer;">` +
                b +
                `</span>
              <span> ) </span>`
            }
            if (str.includes('upstream_ordernumber')) {
              let w = str.split('upstream_ordernumber', 2)[1]
              let a = w.split('(', 2)[1]
              let b = a.split(')', 2)[0]
              str =
                `<span> upstream_ordernumber(</span>
              <span onclick="ercHashJump('${b}')" style="color:#1890ff;cursor:pointer;"">` +
                b +
                `</span>
              <span> ) </span>`
            }
            return str
          })
          item.content = strs.join('|')
        }
      }
      if (item.product_account_type === 'trc20') {
        if (content) {
          const strs = content.split('|').map((str: any) => {
            if (str.includes('system ref')) {
              str = `<span style="color: sandybrown;">` + str + `</span>`
            }
            if (str.includes('deposit_address')) {
              let w = str.split('deposit_address', 2)[1]
              let a = w.split('(', 2)[1]
              let b = a.split(')', 2)[0]
              str =
                `<span> deposit_address(</span>
              <span onclick="jumpAddress('${b}')" style="color:#1890ff;cursor:pointer;">` +
                b +
                `</span>
              <span> ) </span>`
            }
            if (str.includes('upstream_ordernumber')) {
              let w = str.split('upstream_ordernumber', 2)[1]
              let a = w.split('(', 2)[1]
              let b = a.split(')', 2)[0]
              str =
                `<span> upstream_ordernumber(</span>
              <span onclick="hashJump('${b}')" style="color:#1890ff;cursor:pointer;"">` +
                b +
                `</span>
              <span> ) </span>`
            }
            return str
          })
          item.content = strs.join('|')
        }
      }

      return item
    })
  }

  private openDialog(param: any) {
    this.currentOrder = param
    this.dialogVisible = true
  }

  private batchReviewClose() {
    this.dialogVisible1 = false
    this.hadleGetFilesListApi()
  }

  private closeDialog() {
    this.dialogVisible = false
    this.currentOrder = null
    this.hadleGetFilesListApi()
  }

  private openDrawer(param: any) {
    this.currentOrder = param
    this.drawer = true
  }

  private closeDrawer(isManual: boolean = false) {
    if (isManual) {
      this.drawer = false
    }
    this.currentOrder = null
    this.hadleGetFilesListApi()
  }

  // 创建时间监听
  @Watch('date', { immediate: true })
  private pickerChange() {
    if (this.date) {
      this.queryForm.start_time = dateToSeconds(this.date[0])
      this.queryForm.end_time = dateToSeconds(this.date[1])
    } else {
      this.queryForm.start_time = null
      this.queryForm.end_time = null
    }
  }

  private currencyChange() {
    AppModule.SetCurrentCurrencyType(this.queryForm.currency)
    this.reset()
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private async exportData() {
    try {
      this.sendLoading = true
      const data: any = {
        ...this.queryForm,
      }
      delObjEmptyKey(data)
      await antBuyExport(data).then(() => {
        this.$message({
          message: 'The form has been sent to your mailbox, please check it!',
          type: 'success',
        })
        this.sendLoading = false
      })
    } catch (e) {
      this.sendLoading = false
      // this.$message({
      //   message: 'Export failure!',
      //   type: 'error'
      // })
    }
  }

  private reset() {
    this.queryForm = {
      currency: AppModule.currentCurrencyType,
      start_time: null,
      end_time: null,
      status: null,
      content: null,
      begin_handle_time: null,
      end_handle_time: null,
      handle_time_unit: timeTypeList[0],
      product_name: null,
      product_account_name: null,
      exception_type: null,
      upstream_ordernumber: null,
      id: null,
    }
    this.date = getCurrentDate()
    this.handleDate = []
    this.pickerChange()
    this.currentPage = 1
    this.hadleGetFilesListApi()
    this.getProductLists()
  }
  private async init() {
    this.sysType = getType()
    await this.getProductLists()
    await this.hadleGetFilesListApi()
    await AppModule.GetConstant().then((res: any) => {
      this.exTypeList = res.EXCEPTION_TASK_TYPE_CHOICES
    })
  }

  private jumpAddress(row: any) {
    window.open(`https://tronscan.io/#/address/${row}/transfers`)
  }

  private hashJump(row: any) {
    window.open(`https://tronscan.io/#/transaction/${row}`)
  }

  private ercJumpAddress(row: any) {
    window.open(`https://etherscan.io/#/address/${row}/transfers`)
  }
  private ercHashJump(row: any) {
    window.open(`https://etherscan.io/#/transaction/${row}`)
  }

  private sysType: any = ''

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted() {
    ;(window as any).jumpAddress = this.jumpAddress
    ;(window as any).hashJump = this.hashJump
    ;(window as any).ercJumpAddress = this.ercJumpAddress
    ;(window as any).ercHashJump = this.ercHashJump
    this.init()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.rechargeCurrency`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
